import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from 'applib-frontend';
import { Tooltip, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
const TableAddTime = ({ state, id, onAddTime }) => {
    const { intl } = useI18n();
    if (state === 'SUCCESS') {
        return (_jsx("span", { children: _jsx(Tooltip, { title: intl.formatMessage({ id: 'taskComplete' }), color: "  #999", trigger: ['click', 'hover'], children: _jsx(Button, { shape: "circle", icon: _jsx(PlusOutlined, {}), size: "small", className: "btn-time-inactive btn-plus" }) }) }));
    }
    if (state === 'FAILED') {
        return (_jsx("span", { children: _jsx(Tooltip, { title: intl.formatMessage({ id: 'failed_task' }), color: "  #999", trigger: ['click', 'hover'], children: _jsx(Button, { shape: "circle", icon: _jsx(PlusOutlined, {}), size: "small", className: "btn-time-inactive btn-plus" }) }) }));
    }
    return (_jsx(Tooltip, { title: intl.formatMessage({ id: 'plusMinutes' }), color: " #f3ab58", children: _jsx(Button, { onClick: () => onAddTime(true, id), shape: "circle", icon: _jsx(PlusOutlined, {}), size: "small", className: "btn-plus" }) }));
};
export default TableAddTime;
